module.exports = __webpack_public_path__ + "img/cnu_gallery8.c6494c90.jpg";